import { setLoading, setError } from '.';
import getNews from '../services/news-service';

export const articleLoaded = (data) => ({
  type: 'ARTICLES_LOADED',
  payload: data,
});

export const fetchNews = (querie, lang) => (dispatch) => {
  dispatch(setLoading());
  getNews(querie, lang)
    .then((data) => {
      const numberOfTopics = data.articles.length;
      const idGenerator = 103;
      const articles = [];
      for (let i = 0; i < numberOfTopics; i += 1) {
        const topic = {};
        topic.title = data.articles[i].title;
        topic.content = data.articles[i].description;
        topic.link = data.articles[i].url;
        topic.image = data.articles[i].image;
        topic.id = i + idGenerator;
        articles.push(topic);
      }
      dispatch(articleLoaded(articles));
    })
    .catch(() => {
      dispatch(setError('Request limit is reached(news)'));
    });
};
